/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForGcpServiceAccountProtocol extends models.ServiceAccountCredentialsBaseForGcpServiceAccountProtocol {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForGcpServiceAccountProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForGcpServiceAccountProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForGcpServiceAccountProtocol>): ServiceAccountCredentialsForGcpServiceAccountProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForGcpServiceAccountProtocol(), model);
        ServiceAccountCredentialsForGcpServiceAccountProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForGcpServiceAccountProtocol>): ServiceAccountCredentialsForGcpServiceAccountProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForGcpServiceAccountProtocol.newInstance(<ServiceAccountCredentialsForGcpServiceAccountProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForGcpServiceAccountProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForGcpServiceAccountProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForGcpServiceAccountProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForGcpServiceAccountProtocol.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForGcpServiceAccountProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
